import { Link } from 'react-router-dom';
import Avatar from '../../profile/ui/Avatar';
import { ArrowRightIcon } from '../icons';

/**
 * Roster row → links straight to the member's profile page (/profile/:id).
 * The old inline tool-access expander was removed: managers review a member by
 * opening their profile, not by drilling into a per-row tool list.
 * photo_url is resolved server-side the same way the profile resolves it, and
 * Avatar falls back to initials if the image fails to load.
 */
export default function MemberRow({ member }) {
  return (
    <li className="dept2-member-row">
      <Link className="dept2-member-row__head" to={`/profile/${member.id}`}>
        <Avatar name={member.name} src={member.photo_url} size="node" variant="hashed" />
        <span className="dept2-member-row__who">
          <strong>{member.name}</strong>
          <small>{member.email}</small>
        </span>
        <span className="dept2-member-row__view" aria-hidden="true">
          <span className="dept2-member-row__view-text">View profile</span>
          <ArrowRightIcon />
        </span>
      </Link>
    </li>
  );
}
